import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'

const ImagePreview = (props) => {
  const backgroundImage = {
    backgroundImage: `url("${props.reference.urlRawFile}")`,
  }

  return props.isBackGround
    ? (
      <div className={props.className} style={backgroundImage}>
        {props.children}
      </div>
    )
    : <img src={props.reference.urlRawFile} style={{ maxWidth: props.maxWidth || '250px' }} alt="" />
}


ImagePreview.defaultProps = {
  maxWidth: '250px',
  className: `portfolio-image center ${Styles['item-inside']} ${Styles.item}`,
  isBackGround: false,
  children: null,
}

ImagePreview.propTypes = {
  reference: PropTypes.shape({
    urlRawFile: PropTypes.string.isRequired,
  }).isRequired,
  maxWidth: PropTypes.string.isRequired,
  className: PropTypes.string,
  isBackGround: PropTypes.bool,
  children: PropTypes.node,
}

export default ImagePreview
